<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
      <span v-if="index === breadcrumbs.length - 1" class="no-link">{{ item.meta.title }}</span>
      <router-link v-else :to="item.path">{{ item.meta.title }}</router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const breadcrumbs = ref([])

// 生成面包屑导航
const getBreadcrumb = () => {
  // 过滤掉没有meta.title的路由
  const matched = route.matched.filter(item => item.meta && item.meta.title)
  
  // 将匹配到的路由转为面包屑
  breadcrumbs.value = matched
}

// 监听路由变化
watch(
  () => route.path,
  () => {
    getBreadcrumb()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  display: inline-block;
  margin-left: 10px;
  
  .no-link {
    color: #97a8be;
    cursor: text;
  }
}
</style> 